import { Mail, MessageSquare, MapPin, Send, ExternalLink } from 'lucide-react';
import { motion } from 'motion/react';

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navigation
      <nav className="fixed top-0 w-full z-50 bg-surface/80 backdrop-blur-xl shadow-[0px_24px_48px_rgba(15,15,27,0.4)]">
        <div className="flex justify-between items-center px-8 py-6 max-w-7xl mx-auto">
          <div className="text-2xl font-bold tracking-tighter text-primary">Guandolo</div>
          <div className="hidden md:flex items-center space-x-10 font-light tracking-tight">
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#">Home</a>
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#">Services</a>
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#">Projects</a>
            <a className="text-primary border-b-2 border-primary pb-1" href="#">Contact</a>
          </div>
          <button className="bg-gradient-to-br from-primary to-primary-container text-on-primary px-6 py-2.5 rounded-xl font-medium scale-95 active:scale-90 transition-transform">
            Get Started
          </button>
        </div>
      </nav> */}

      <main className="pt-32 pb-24 flex-grow">
        {/* Hero Section */}
        <header className="max-w-7xl mx-auto px-8 mb-24">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="text-[3rem] font-extrabold tracking-[-0.04em] leading-none mb-6 text-primary"
          >
            Let's curate your <br />next digital masterpiece.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="text-xl text-on-surface-variant max-w-2xl leading-relaxed"
          >
            Whether it's a bold new project or a subtle refinement, we are here to provide quiet authority and technical excellence.
          </motion.p>
        </header>

        {/* Main Content: Bento Grid Layout */}
        <section className="max-w-7xl mx-auto px-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Contact Form Module */}
          {/* <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7 bg-surface-container-high rounded-xl p-10 shadow-[0px_24px_48px_rgba(15,15,27,0.4)]"
          >
            <h2 className="text-2xl font-light mb-8 text-on-surface">Send a Message</h2>
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant font-medium">Name</label>
                  <input 
                    className="w-full bg-surface-container-lowest border-none ring-1 ring-outline-variant/15 focus:ring-primary/40 rounded-xl px-4 py-3 text-on-surface placeholder:text-slate-600 transition-all outline-none" 
                    placeholder="John Doe" 
                    type="text"
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant font-medium">Email Address</label>
                  <input 
                    className="w-full bg-surface-container-lowest border-none ring-1 ring-outline-variant/15 focus:ring-primary/40 rounded-xl px-4 py-3 text-on-surface placeholder:text-slate-600 transition-all outline-none" 
                    placeholder="john@example.com" 
                    type="email"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <label className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant font-medium">Subject</label>
                <select className="w-full bg-surface-container-lowest border-none ring-1 ring-outline-variant/15 focus:ring-primary/40 rounded-xl px-4 py-3 text-on-surface transition-all outline-none appearance-none">
                  <option>Design Inquiry</option>
                  <option>Development Project</option>
                  <option>Consultancy</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant font-medium">Message</label>
                <textarea 
                  className="w-full bg-surface-container-lowest border-none ring-1 ring-outline-variant/15 focus:ring-primary/40 rounded-xl px-4 py-3 text-on-surface placeholder:text-slate-600 transition-all outline-none resize-none" 
                  placeholder="Tell us about your vision..." 
                  rows={5}
                ></textarea>
              </div>
              <button className="w-full md:w-auto bg-gradient-to-br from-primary to-primary-container text-on-primary px-10 py-4 rounded-xl font-bold tracking-tight hover:shadow-[0px_0px_20px_rgba(192,193,255,0.3)] transition-all" type="submit">
                Dispatch Message
              </button>
            </form>
          </motion.div> */}

          {/* Contact Details & Map Module */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5 flex flex-col gap-8"
          >
            {/* Info Card */}
            <div className="bg-surface-container-low p-8 rounded-xl space-y-10">
              <div className="flex items-start gap-6">
                <div className="p-3 rounded-full bg-primary/10 text-primary">
                  <Mail size={24} />
                </div>
                <div>
                  <p className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant mb-1">Email us</p>
                  <p className="text-lg font-medium text-on-surface">juanhenaob@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start gap-6">
                <div className="p-3 rounded-full bg-primary/10 text-primary">
                  <MessageSquare size={24} />
                </div>
                <div>
                  <p className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant mb-1">Phone & WhatsApp</p>
                  <p className="text-lg font-medium text-on-surface">(57) 301 328 30 81</p>
                </div>
              </div>
              <div className="flex items-start gap-6">
                <div className="p-3 rounded-full bg-primary/10 text-primary">
                  <MapPin size={24} />
                </div>
                <div>
                  <p className="text-[0.75rem] uppercase tracking-widest text-on-surface-variant mb-1">Location</p>
                  <p className="text-lg font-medium text-on-surface leading-snug">
                    Edificio Mar del Norte,<br />
                    Cartagena, Colombia
                  </p>
                </div>
              </div>
            </div>

            {/* Map Card */}
            <div className="flex-grow min-h-[300px] rounded-xl overflow-hidden relative group">
              <iframe
                src="https://maps.google.com/maps?q=Edificio%20Mar%20del%20Norte,%20Cartagena,%20Colombia&t=&z=15&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0 grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700"
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>

              <div className="absolute inset-0 bg-surface-container-highest/40 backdrop-blur-[2px] z-10 pointer-events-none group-hover:opacity-0 transition-opacity flex items-center justify-center">
                <span className="text-primary font-medium tracking-widest uppercase text-xs">Explore Map</span>
              </div>

              {/* Floating Overlay for context */}
              <div className="absolute bottom-4 left-4 right-4 glass-panel p-4 rounded-xl z-20 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-primary animate-pulse"></div>
                  <span className="text-xs font-medium text-on-surface tracking-tight">Active Studio · Cartagena</span>
                </div>
                <ExternalLink size={16} className="text-primary" />
              </div>
            </div>
          </motion.div>
        </section>

        {/* Asymmetric Quote Section */}
        <section className="max-w-7xl mx-auto px-8 mt-48 grid grid-cols-1 md:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="md:col-start-7 md:col-span-6"
          >
            <span className="text-primary text-6xl font-serif italic opacity-30 select-none">“</span>
            <p className="text-2xl font-light text-on-surface-variant italic -mt-8 leading-relaxed">
              Design is not just what it looks like and feels like. Design is how it works. We ensure it works beautifully.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <div className="h-[1px] w-12 bg-outline-variant/30"></div>
              <span className="text-[0.75rem] uppercase tracking-[0.2em] text-primary">The Guandolo Ethos</span>
            </div>
          </motion.div>
        </section>
      </main>

      {/* Footer
      <footer className="bg-surface-container-low w-full py-12">
        <div className="flex flex-col md:flex-row justify-between items-center px-8 max-w-7xl mx-auto">
          <div className="mb-8 md:mb-0">
            <div className="text-lg font-bold text-primary mb-2">Guandolo</div>
            <p className="text-sm text-on-surface-variant">© 2024 Guandolo. The Digital Curator.</p>
          </div>
          <div className="flex gap-8">
            <a className="text-sm text-on-surface-variant hover:text-primary transition-colors" href="#">Privacy Policy</a>
            <a className="text-sm text-on-surface-variant hover:text-primary transition-colors" href="#">Terms of Service</a>
            <a className="text-sm text-on-surface-variant hover:text-primary transition-colors" href="#">LinkedIn</a>
            <a className="text-sm text-on-surface-variant hover:text-primary transition-colors" href="#">Instagram</a>
          </div>
        </div>
      </footer> */}
    </div>
  );
}
